module.exports = __webpack_public_path__ + "708314e58536b884cf860e392f90b753.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/logo/horizontal-white.png
// module id = ./app/img/logo/horizontal-white.png
// module chunks = 10